<script setup lang="ts">
const props = defineProps<{
	announcements: string[];
}>();
</script>

<template>
	<div
		class="marquee-content flex items-center will-change-transform"
		:style="{ animationDuration: '20s' }"
	>
		<div
			class="flex items-center justify-evenly min-w-[100vw] whitespace-nowrap px-10xl"
		>
			<span
				v-for="(announcement, idx) in announcements"
				:key="`${props.announcements.length > 1 ? 'set' : ''}-${idx}`"
				class="flex-shrink-0"
				:class="idx !== announcements.length - 1 ? 'mr-10xl' : ''"
			>
				{{ announcement }}
			</span>
		</div>
	</div>
</template>

<style scoped>
.marquee-content {
	animation: marquee linear infinite;
}
</style>
